import React from 'react'

export default _ =>
  <svg {..._} width='28' height='29' xmlns='http://www.w3.org/2000/svg'>
    <g stroke='currentColor' strokeWidth='2' fill='none' fillRule='evenodd'>
      <path d='M13.862 1.583C6.758 1.583 1 7.323 1 14.402c0 7.08 5.758 12.819 12.862 12.819 7.103 0 12.861-5.74 12.861-12.82 0-7.321-5.45-12.818-12.861-12.818zM9.568 18.359l8.147-7.913M17.715 18.359l-8.147-7.913' />
    </g>
  </svg>
